import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as emailTemplateAction from './../../../../../actions/emailTemplateAction';
import EmailTemplateDetail from './EmailTemplateDetail';

const mapStateToProps = state => {
    return {
        emailTemplateState: state.emailTemplateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmailTemplateDetail: (id) => dispatch(emailTemplateAction.getEmailTemplateDetail(id)),
        setEmailTemplateDetail: (emailTemplate) => dispatch(emailTemplateAction.setEmailTemplateDetail(emailTemplate)),
        updateEmailTemplate: (emailTemplate) => dispatch(emailTemplateAction.updateEmailTemplateDetail(emailTemplate)),
        createEmailTemplate: (emailTemplate) => dispatch(emailTemplateAction.createEmailTemplateDetail(emailTemplate)),
        createEmailTemplateTranslate: (emailTemplate, language) => dispatch(emailTemplateAction.createEmailTemplateTranslate(emailTemplate, language)),
        updateEmailTemplateTranslate: (emailTemplate, language) => dispatch(emailTemplateAction.updateEmailTemplateTranslate(emailTemplate, language)),
        deleteEmailTemplateTranslate: (emailTemplate, refreshParams) => dispatch(emailTemplateAction.deleteEmailTemplateTranslate(emailTemplate, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EmailTemplateDetail));
